import { render, staticRenderFns } from "./ModalConfiguracaoUsuario.vue?vue&type=template&id=61bdfda4&scoped=true&"
import script from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracaoUsuario.vue?vue&type=style&index=0&id=61bdfda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdfda4",
  null
  
)

export default component.exports